import clsx from 'clsx';
import { FunctionComponent } from 'react';
import Price from './Price';
import styles from './Item.module.scss';

interface ItemProps {
    description?: string;
    price: string;
    refund?: boolean;
    className?: string;
}

export const Item: FunctionComponent<ItemProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={styles.left}>
                <p className={clsx(styles.text, { [styles.refund]: props.refund })}>{props.description}</p>
            </div>
            <div className={styles.right}>
                <Price
                    refund={props.refund}
                    price={props.price}
                />
            </div>
        </div>
    );
};

export default Item;
